import { useState } from "react";
import { TableColumn } from "react-data-table-component";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import {
  SIDEBAR_MENU_OPTIONS,
  SIDEBAR_ROLES,
} from "../../../components/CommonComponents/Navbar/sidebar/sidebarMenuVisibility";
import Table, {
  tableCustomStyles,
} from "../../../components/CommonComponents/Table/Table";
import PageHeader from "../../../components/pageHeader/pageHeader";
import style from "../../../components/SidebarMenuConfig/SidebarMenuConfig.module.css";
import SidebarMenuToggle from "../../../components/SidebarMenuConfig/SidebarMenuToggle";

type TMenuRow = (typeof SIDEBAR_MENU_OPTIONS)[number];

/** One row per switchable entry, one switch column per reviewer level. */
const columns: TableColumn<TMenuRow>[] = [
  { name: "Sidebar Menu", selector: (row) => row.label },
  ...SIDEBAR_ROLES.map((role) => ({
    name: role,
    cell: (row: TMenuRow) => (
      <SidebarMenuToggle
        role={role}
        menuKey={row.menuKey}
        menuLabel={row.label}
      />
    ),
  })),
];

/**
 * Admin screen of the Sidebar Menu Config feature: choose which of the
 * switchable sidebar entries Level 1, Level 2 and Level 3 are shown. The
 * screen only lays out the grid; each change is made by SidebarMenuToggle.
 */
export default function SidebarMenuConfig() {
  /** The header needs a search value even though this screen has no search. */
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div>
      <div className={style.bodyBox}>
        <PageHeader
          title="Sidebar Menu Config"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={false}
          showAdditionalButton={false}
          buttonTitle=""
          showGridButton={false}
          showFilterButton={false}
        />

        <p className={style.sectionTitle}>
          Switch on the entries each level should see in its sidebar
        </p>
        <BoxComponent>
          <Table
            columns={columns as TableColumn<unknown>[]}
            data={SIDEBAR_MENU_OPTIONS}
            customStyles={tableCustomStyles}
            isPagination={false}
          />
        </BoxComponent>
      </div>
    </div>
  );
}
